import {useCallback,useEffect,useRef,useState} from 'react';
import {doc,getDoc,setDoc} from '../../lib/auditedFirestore';
import {db} from '../../lib/firebase';
export const GUIDE_VERSION=1;
const memory=new Map();
export const guideKey=uid=>`instil-student-guide:v${GUIDE_VERSION}:${uid}`;
export function cleanProgress(value={}) {
    if(value?.version!==GUIDE_VERSION)value={};
    return {version:GUIDE_VERSION,welcomeSeen:value.welcomeSeen===true,tutorialCompleted:value.tutorialCompleted===true,
        positionSeconds:Number.isFinite(value.positionSeconds)?Math.max(0,Math.min(7200,value.positionSeconds)):0,
        updatedAt:Number.isFinite(value.updatedAt)?Math.max(0,value.updatedAt):0};
}
export function readProgress(uid) {
    let stored;try{stored=JSON.parse(localStorage.getItem(guideKey(uid)));}catch{/* Browser storage may be disabled. */}
    const cached=memory.get(uid);
    return cleanProgress(cached && (!stored || cached.updatedAt>=stored.updatedAt)?cached:stored);
}
export function mergeProgress(local,remote) {
    const a=cleanProgress(local),b=cleanProgress(remote),latest=a.updatedAt>=b.updatedAt?a:b;
    return {...latest,welcomeSeen:a.welcomeSeen || b.welcomeSeen,tutorialCompleted:a.tutorialCompleted || b.tutorialCompleted};
}
function remember(uid,value) {
    memory.set(uid,value);
    try{localStorage.setItem(guideKey(uid),JSON.stringify(value));return true;}catch{return false;}
}
export function useGuideProgress(uid,enabled) {
    const [state,setState]=useState({uid:null,ready:false,progress:cleanProgress(),sync:'loading'});
    const writes=useRef(Promise.resolve());
    useEffect(()=>{
        if(!uid || !enabled){setState({uid:null,ready:false,progress:cleanProgress(),sync:'idle'});return;}
        let active=true,settled=false;
        const local=readProgress(uid);
        setState({uid,ready:false,progress:local,sync:'loading'});
        const finish=(remote,ok)=>{
            if(!active || settled)return;settled=true;clearTimeout(timeout);
            const progress=mergeProgress(readProgress(uid),remote),localSaved=remember(uid,progress);
            setState({uid,ready:true,progress,sync:ok?'synced':localSaved?'device':'session'});
        };
        // An unavailable preference service must never prevent access to learning.
        const timeout=setTimeout(()=>finish(null,false),4500);
        getDoc(doc(db,'studentOnboarding',uid)).then(snapshot=>finish(snapshot.exists()?snapshot.data():null,true)).catch(()=>finish(null,false));
        return()=>{active=false;clearTimeout(timeout);};
    },[uid,enabled]);
    const save=useCallback((patch,sync=true)=>{
        if(!uid || !enabled)return;
        const current=readProgress(uid),next=cleanProgress({...current,...patch,version:GUIDE_VERSION,updatedAt:Date.now()});
        // Dismissal/completion are monotonic even if a delayed player update arrives.
        next.welcomeSeen=next.welcomeSeen || current.welcomeSeen;next.tutorialCompleted=next.tutorialCompleted || current.tutorialCompleted;
        const localSaved=remember(uid,next);
        setState(s=>s.uid===uid?{...s,progress:next,ready:true,sync:localSaved?s.sync:'session'}:s);
        if(sync){
            writes.current=writes.current.catch(()=>{}).then(()=>setDoc(doc(db,'studentOnboarding',uid),readProgress(uid)))
                .then(()=>setState(s=>s.uid===uid?{...s,sync:'synced'}:s))
                .catch(()=>setState(s=>s.uid===uid?{...s,sync:localSaved?'device':'session'}:s));
        }
    },[uid,enabled]);
    const current=state.uid===uid?state:{uid,ready:false,progress:cleanProgress(),sync:'loading'};
    return {...current,save};
}
